import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import "./OrderProgressStepper.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { IDS } from "../../../../utils/common";
// Custom StepIcon Component

export function VerticalLinearStepper({ order }) {
  let steps;

 

  if (Number(order?.order_status_id) === Number(IDS.order_status.Returned)) {
    steps = [
      {
        label: "Return Requested",
        description: "Your order has been Return Requested.",
        status:
          order?.return_order?.return_status_id ==
          IDS.return_status.ReturnRequested
            ? "completed"
            : order?.return_order?.return_status_id >=
              IDS.return_status.ReturnRequested
            ? "completed"
            : "disabled",
      },
      {
        label: "Return Approved",
        //   description: "Your order will be ready to pick up shorty",
        status:
          Number(order?.return_order?.return_status_id) ===
          Number(IDS.return_status.ReturnApproved)
            ? "completed"
            : Number(order?.return_order?.return_status_id) >=
              Number(IDS.return_status.ReturnApproved)
            ? "completed"
            : "disabled",
      },
      {
        label: "Order Shipped",
        //   description: "Your order has been recieved",
        status:
          order?.return_order?.return_status_id ==
          IDS.return_status.ProductPicked
            ? "completed"
            : order?.return_order?.return_status_id >=
              IDS.return_status.ProductPicked
            ? "completed"
            : "disabled",
      },
      {
        label: "Returned",
        status:
          order?.return_order?.return_status_id == IDS.return_status.Returned
            ? "completed"
            : order?.return_order?.return_status_id >=
              IDS.return_status.Returned
            ? "completed"
            : "disabled",
      },
    ];
  } else {
    steps = [
      {
        label: "Ordered",
        description: "Your order has been received.",
        status:
          order?.order_status_id == IDS.order_status.Ordered
            ? "completed"
            : order?.order_status_id >= IDS.order_status.Ordered
            ? "completed"
            : "disabled",
      },
      {
        label: "Processing Your Order",
        description: "Your order will be ready to pick up shorty",
        status:
          Number(order?.order_status_id) === Number(IDS.order_status.Processing)
            ? "completed"
            : Number(order?.order_status_id) >=
              Number(IDS.order_status.Processing)
            ? "completed"
            : "disabled",
      },
      {
        label: "Order Shipped",
        description: "Your order has been Shipped",
        status:
          order?.order_status_id == IDS.order_status.Shipped
            ? "completed"
            : order?.order_status_id >= IDS.order_status.Shipped
            ? "completed"
            : "disabled",
      },
      {
        label: "Delivered",
        status:
          order?.order_status_id == IDS.order_status.Deliverd
            ? "completed"
            : order?.order_status_id >= IDS.order_status.Deliverd
            ? "completed"
            : "disabled",
      },
    ];
  }

  return (
    <Box sx={{ maxWidth: 400 }} className="stepper_box">
      <div className="OrderProgressStepper"></div>

      <div className="simple-stepper">
        {steps.map((step, index) => (
          <div key={index} className={`step ${step.status}`}>
            <div className="circle">
              {step.status === "completed" ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="completed_step"
                />
              ) : step.status === "active" ? (
                <div className="current_step_outer_circle">
                  <div className="current_step_inner_circle"></div>
                </div>
              ) : (
                <div className="disabled_outer">
                  <div className="circle-status disabled"></div>
                </div>
              )}
            </div>
            <div
              className={`content ${
                step.status === "disabled" ? "disabled-content" : ""
              }`}
            >
              {index === 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>

                  {/* <Link to={`tel:+${order?.delivery_boy?.contact_no}`}>
                                        <div className="call_icon_holder">
                                            <div className="icon_holder">
                                                <FontAwesomeIcon icon={faPhone} className="call_icon" />
                                            </div>
                                            <div className="">
                                                <p className="icon_text">Call Store   </p>
                                            </div>
                                        </div>
                                    </Link> */}
                </div>
              ) : index !== 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {/* <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step
                        key={step.label}
                        completed={completedSteps.includes(index)}
                        disabled={step.disabled}
                    >
                        <StepLabel
                            StepIconComponent={(props) => (
                                <CustomStepIcon {...props} disabled={step.disabled} />
                            )}
                            classes={{
                                labelContainer: step.disabled ? "disabled_label" : "",
                            }}
                        >
                            <div
                                className={`step_data_container ${step.disabled ? "disabled_container" : ""
                                    }`}
                            >
                                <div className="main_step">
                                    <p className={`title ${step.disabled ? "disabled_text" : ""}`}>
                                        {step?.label}
                                    </p>
                                    <p
                                        className={`sub_title ${step.disabled ? "disabled_text" : ""
                                            }`}
                                    >
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper> */}
    </Box>
  );
}

const OrderProgressStepper = ({ order }) => {
  return (
    <div className="OrderProgressStepper">
      <VerticalLinearStepper order={order} />
    </div>
  );
};

export default OrderProgressStepper;
